<template>
    <div class="member" v-if="isActive">
        <h3 class="member__ttl"  v-if="form.first_name && form.last_name">
            <i class="fa-solid fa-user-group"></i>
            {{ form.first_name }} {{ form.last_name }}
        </h3>
        <h3 class="member__ttl"  v-else>
            <i class="fa-solid fa-user-group"></i>
            GROUP MEMBER
        </h3>
        <ValidationObserver class="member__inner" ref="form">
            <div class="row mb-4">
                <ValidationProvider
                    class="col-md-6"
                    name="First Name"
                    v-slot="{ errors }"
                    rules="required|latin|min:3|max:100"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">First Name*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.first_name"
                        >
                        <FormError :error="errors[0]" name="First Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Last Name"
                    v-slot="{ errors }"
                    rules="required|latin|min:3|max:100"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Last Name*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.last_name"
                        >
                        <FormError :error="errors[0]" name="Last Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Date og Birth"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Date og Birth*</label>
                        <input
                            type="date"
                            class="form-control pl-4"
                            v-model="form.dob"
                        >
                        <FormError :error="errors[0]" name="Date og Birth"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Place of Birth"
                    v-slot="{ errors }"
                    rules="required|latin|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Place of Birth*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.birth_place"
                        >
                        <FormError :error="errors[0]" name="Place of Birth"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Cell phone"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Cell phone*</label>
                        <input
                            type="tel"
                            class="form-control pl-4"
                            v-mask="'+1 (###) ###-####'"
                            v-model="form.cell_phone"
                        >
                        <FormError :error="errors[0]" name="Cell phone"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Home Phone"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Home Phone*</label>
                        <input
                            type="tel"
                            class="form-control pl-4"
                            v-mask="'+1 (###) ###-####'"
                            v-model="form.home_phone"
                        >
                        <FormError :error="errors[0]" name="Home Phone"/>
                    </div>
                </ValidationProvider>
            </div>

            <h3 class="profile__ttl">Passport Information:</h3>
            <div class="row mb-4">
                <ValidationProvider
                    class="col-md-6"
                    name="Legal Name"
                    v-slot="{ errors }"
                    rules="required|latin|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Legal Name (Exactly as it appears in your passport)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.legal_name"
                        >
                        <FormError :error="errors[0]" name="Legal Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Passport Number"
                    v-slot="{ errors }"
                    rules="required|min:2"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Passport Number</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.number"
                        >
                        <FormError :error="errors[0]" name="Passport Number"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Date of Issue"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Passport Date of Issue</label>
                        <input
                            type="date"
                            class="form-control pl-4"
                            v-model="form.date_of_issue"
                        >
                        <FormError :error="errors[0]" name="Date of Issue"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Date of Expiry"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Passport Date of Expiry</label>
                        <input
                            type="date"
                            class="form-control pl-4"
                            v-model="form.date_of_expiry"
                        >
                        <FormError :error="errors[0]" name="Date of Expiry"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Nationality"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Passport Nationality (Country of issue)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.nationality"
                        >
                        <FormError :error="errors[0]" name="Nationality"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Authority"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Passport Authority (Place of issue)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.place_of_issue"
                        >
                        <FormError :error="errors[0]" name="Authority"/>
                    </div>
                </ValidationProvider>
            </div>

            <h3 class="profile__ttl">Scanned Copies*</h3>

            <div class="passport mb-5">
                <PhotoDocumentContainer
                    :title="`Passport page with photo and information*`"
                    :file="form.passport_photo"
                    :field="`passport_photo`"
                    @update-photo="updateDocumentPhoto"
                />

                <PhotoDocumentContainer
                    :title="`Visa*`"
                    :file="form.visa_photo"
                    :field="`visa_photo`"
                    @update-photo="updateDocumentPhoto"
                />

                <PhotoDocumentContainer
                    :title="`Residency Card*`"
                    :file="form.residency_card_photo"
                    :field="`residency_card_photo`"
                    @update-photo="updateDocumentPhoto"
                />


            </div>

            <h3 class="profile__ttl">Cabins information*</h3>
            <div class="row mb-4">
                <ValidationProvider
                    class="col-md-6"
                    name="Number of Cabins"
                    v-slot="{ errors }"
                    rules="required"

                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Number of Cabins Required</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="form.cabins"
                        >
                        <FormError :error="errors[0]" name="Number of Cabins"/>
                        <small class="form-txt">Most cruise lines only offer one cabin, so if you indicate more than one cabin, make sure it is necessary</small>
                    </div>
                </ValidationProvider>
            </div>

            <div class="member__actions">
                <a
                    href="javascript:void(0)"
                    class="cancel"
                    @click.prevent="$emit('remove',index)"
                >
                    Cancel
                </a>
                <span class="sep"></span>
                <a
                    @click.prevent="validate"
                    href="javascript:void(0)"
                >
                    Save
                </a>
            </div>

        </ValidationObserver>
    </div>

    <div class="member member_collapsed" v-else >
        <h3 class="member__ttl">
            <i class="fa-solid fa-user-group"></i>
            {{ member.first_name }} {{ member.last_name }}
        </h3>
        <button
            class="member__button"
            @click="$emit('activate', index)"
        >
            <i class="fa-solid fa-chevron-down"></i>
        </button>
        <button
            class="member__delete"
            @click.prevent="$emit('remove',index, member)"
        >
            <svg width="16" height="16">
                <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
            </svg>
        </button>

    </div>

</template>

<script>
import PhotoDocumentContainer from "../Common/PhotoDocumentContainer.vue";
import FileContainer from "../Common/FileContainer.vue";
import FormError from "../Common/FormError.vue";

export default {
    name: 'GroupMemberForm',
    components: {FormError, FileContainer, PhotoDocumentContainer},
    props: {
        isActive: {
            type: Boolean,
            default: false,
            required: true
        },
        member:{
            type: Object,
        },
        index: Number
    },
    emits: ['save-form', 'activate', 'remove'],
    data() {
        return {
            form: {
                first_name: null,
                last_name: null,
                dob: null,
                birth_place: null,
                cell_phone: null,
                home_phone: null,
                legal_name: null,
                number: null,
                date_of_issue: null,
                date_of_expiry: null,
                nationality: null,
                place_of_issue: null,
                cabins: null,
                passport_photo: null,
                passport_photo_id: null,
                residency_card_photo: null,
                residency_card_photo_id: null,
                visa_photo: null,
                visa_photo_id: null,
            }
        }
    },
    methods: {
        updateDocumentPhoto(field, file) {
            if (file ===  null) {
                this.form[field] = null
                this.form[`${field}_id`] = null
            } else {
                this.form[field] = file;
                this.form[`${field}_id`] = file.id
            }
        },

        setData() {
            Object.keys(this.member).forEach((key) => {
                this.form[key] = this.member[key]
            });
        },
        sendDataForSaving() {
            this.$emit('save-form', { form: this.form, index: this.index });
        },
        async validate() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
            } else {
                this.sendDataForSaving()
            }
        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        member: {
            handler: function (newInfo) {
                if (newInfo !== this.form) {
                    this.setData();
                }
            },
            immediate: true,
        },
    }
}

</script>

<style scoped>

</style>
